// `index.tsx` gates the buttons on `loadedOnMouseMove`, so this section renders
// nothing during SSR and only mounts on the client. Left as a lazily-imported
// section the framework flagged it as eager-but-not-sync ("may cause blank
// content during hydration") and its chunk mounted late/unreliably. Bundling
// the tiny wrapper synchronously (like Modals/Minicart) makes it mount
// deterministically on hydration and silences that warning; the heavy buttons
// stay code-split behind index.tsx's own React.lazy + `loadedOnMouseMove` gate,
// so the post-`load` deferral is preserved. The gating signal itself never
// flipping was the primary cause — fixed in sdk/useUI.ts. See DECO-5435.
export const sync = true

export { default } from "~/components/floatingButtons/index"
export { default as LoadingFallback } from "~/components/LoadingFallback"
